<template>
  <div>
    <el-button @click="openDialog">{{$t(btnTitle) }}</el-button>
    <h-dialog
      :title="$t('common.listConfig')"
      v-model="mOpen"
      :confirmLoading="loading"
      :footer="false"
      width="550px"
      top="3vh"
    >
      <div class="dialog-content">
        <div class="tip">
          {{ $t('orderModules.salesOrder.listConfigHint') }} </div>
        <el-table
          :data="returnSource"
          row-key="prop"
          id="sortTable"
          style="width: 100%; padding-bottom: 30px"
          :header-cell-style="{
            backgroundColor: '#fafafa',
            fontWeight: 800
          }"
          height="650px"
        >
          <el-table-column :label="$t('orderModules.salesOrder.listConfigShow')" width="100" align="center">
            <template #default="{ row }">
              <el-checkbox
                v-model="row.dragSortConfig.show"
                :disabled="row.dragSortConfig.disabled"
                :key="row.order"
                label=""
                size="large"
              />
            </template>
          </el-table-column>
          <el-table-column prop="label" :label="$t('orderModules.salesOrder.columnName')" width="280" align="center" />
          <el-table-column :label="$t('orderModules.salesOrder.dragReorder')" width="120" align="center">
            <template #default="{ row }">
              <img src="./sort-img.png" style=""
                   :style="`width: 22px; height: 22px; cursor: ${row.dragSortConfig.disabled ? 'not-allowed' : 'move'}; pointer-events: ${row.dragSortConfig.disabled ? 'none' : 'auto'};`"
                   :class="{ move: !row.dragSortConfig.disabled }" />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <template #footer>
        <div
          style="display: flex; justify-content: space-between; align-items: center;"
        >
          <el-button type="primary" @click="resetData">{{ $t('orderModules.salesOrder.restoreDefaults') }}</el-button>
          <div>
            <el-button @click="cancel">{{ $t('commonComponents.cancelText') }}</el-button>
            <el-button
              style="width: 130px;"
              type="primary"
              @click="ok"
            >
              {{ $t('orderModules.salesOrder.save') }} </el-button>
          </div>
        </div>
      </template>
    </h-dialog>
  </div>
</template>

<script setup>
import { ref, nextTick, unref } from 'vue'
import { ElMessage } from 'element-plus'
import { enableRowDrop } from '@/utils/drag-sort'
import { deepClone } from '@/utils/tools'
import dragOptions from '@/assets/images/home/drag-options.png'
import { $t } from '@/i18n'
const props = defineProps({
  btnTitle: {
    type: String,
    default: $t('common.listConfig')
  },
  defaultColumns: {
    type: Array,
    required: true
  },
  minNumber: {
    type: Number,
    default: 5
  },
  setCurrentColumns: {
    type: Function,
    default: () => {
    }
  }
})

const sortColumns = defineModel('sortColumns', {
  type: Array,
  required: true
})

const mOpen = ref(false)
const loading = ref(false)
const returnSource = ref([])

const openDialog = async () => {
  mOpen.value = true
  returnSource.value = deepClone(sortColumns.value)
  await nextTick()
  enableRowDrop(setNewSortArray, returnSource.value, true, 'sortTable')
}

const setNewSortArray = (sortArray) => {
  if (sortArray) {
    returnSource.value = sortArray
  }
}


const ok = async () => {
  const flag = await props.setCurrentColumns(returnSource.value)
  if (flag) {
    sortColumns.value = returnSource.value
    ElMessage({
      type: 'success',
      message: $t('common.operatorOK')
    })
  }
  mOpen.value = false
}

const cancel = () => {
  mOpen.value = false
}

const resetData = async () => {
  returnSource.value = deepClone(props.defaultColumns)
  ElMessage.success($t('orderModules.salesOrder.columnHint'))
}
</script>

<style lang="scss" scoped>
.dialog-content {
  max-height: 700px;
  overflow-y: hidden;
}

.tip {
  padding-bottom: 30px;
}
</style>
